import React, { memo, RefObject, useState, useEffect } from "react";
import styles from "./CaptionsPanel.module.css";
import Caption from "./Caption";
import { VideoCaption } from "../../../../../common/video/models/VideoCaption";
import RerunSTTComponent from "../../../../../pages/vod/Common/RerunSTT";
import PuiTypography from "../../../../../components/elements/PuiTypography";
import { isAdmin, isEditor } from "../../../../../utils/LogicUtils";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../root/RootReducer";
import { IsDevice } from "../../../../../components/function/useDeviceFlag";

interface CaptionsPanelProps {
    videoId: number;
    captions: VideoCaption[];
    videoRef: RefObject<HTMLVideoElement>;
    currentVideoTimeMs: number;
    setEditModalOpen: (target: boolean) => void;
}

function CaptionsPanel({
    videoId,
    captions,
    videoRef,
    currentVideoTimeMs,
    setEditModalOpen,
}: CaptionsPanelProps) {
    const { user } = useSelector((state: AppState) => ({
        user: state.user.user,
    }));
    const [currentCaptionIndex, ChangeCurrentCaptionIndex] = useState(-1);

    const endMillisList: number[] = [];
    captions.map(function (row) {
        endMillisList.push(row.endMillis);
        return null;
    });

    // 現在のキャプションのインデックスを決める
    useEffect(() => {
        ChangeCurrentCaptionIndex(
            endMillisList.findIndex((endTime) => endTime > currentVideoTimeMs)
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentVideoTimeMs]);

    return (
        <div className={styles.root}>
            {
                IsDevice("desktop") &&
                (isAdmin(user?.roles) || isEditor(user?.roles)) &&
                <RerunSTTComponent videoId={videoId} />
            }
            <div className={styles.captionListArea}>
                <div className={styles.captionList} id="captionTop">
                    {captions.map((segment, index) => (
                        <Caption
                            key={index}
                            isCurrentCaption={index === currentCaptionIndex}
                            videoRef={videoRef}
                            startTimeMillis={segment.startMillis}
                            id={captions[index].id}
                            text={segment.transcript}
                            captionElement={document.getElementById("captionTop")}
                            setEditModalOpen={setEditModalOpen}
                        >
                            <PuiTypography>{segment.transcript}</PuiTypography>
                        </Caption>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default memo(CaptionsPanel);
